export default __webpack_public_path__ + "static/media/score.b3a6006c.svg";